import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface LegendProps {
  children: ReactNode;
  screenReaderOnly?: boolean;
  className?: string;
  id?: string;
  variant?: 'large';
}

const Legend = ({ children, screenReaderOnly, className, id, variant }: LegendProps): JSX.Element => {
  return (
    <legend
      id={id}
      className={classNames(
        'usa-legend',
        {
          [`usa-legend--${variant || ''}`]: variant,
          'usa-sr-only': screenReaderOnly,
        },
        className,
      )}
    >
      {children}
    </legend>
  );
};

export default Legend;
